"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dateFormat = require('dateformat');
class DateFormatter {
    /**
     * Formats date.
     *
     * @see https://www.npmjs.com/package/dateformat
     *
     * @param date
     * @param format
     */
    format(date, format) {
        return dateFormat(date, format);
    }
}
exports.default = DateFormatter;
